import React from 'react';
import PropTypes from 'prop-types';

class PercentCompleteFormatter extends React.Component {
  static propTypes = {
    value: PropTypes.number.isRequired
  };

  render() {
    const percentComplete = this.props.value + '%';
    if (this.props.value >= 0) {
      return (
        <div className="progress" style={{marginTop: '20px'}}>
          <div className="progress-bar" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style={{width: percentComplete}}>
            {percentComplete}
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default PercentCompleteFormatter;


// WEBPACK FOOTER //
// ./src/components/Percentaje.jsx